
  <h1 mat-dialog-title style="color: #424242;">Add Utility</h1>

  <div [formGroup]="utilityForm">
    <mat-radio-group formControlName="type" style="display: flex; gap: 24px; margin-bottom: 16px;">
      <mat-radio-button value="gas">Gas</mat-radio-button>
      <mat-radio-button value="electric">Electric</mat-radio-button>
    </mat-radio-group>

    <mat-form-field style="width: 100%;">
      <mat-label>Utility Company</mat-label>
      <input matInput formControlName="company" maxlength="100" autocomplete="off">
    </mat-form-field>
    <div *ngIf="isDuplicate()" style="color: #d32f2f; font-size: 13px;">
      This {{ utilityForm.get('type').value === 'gas' ? 'gas' : 'electric' }} utility already exists.
    </div>

    <div mat-dialog-actions>
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-button [disabled]="utilityForm.invalid || isDuplicate() || saving" (click)="save()">Save</button>
    </div>
  </div>
  